import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/main.css";
import '../node_modules/bootstrap-icons/font/bootstrap-icons.min.css';
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
